$(document).ready(function() {
    $('.portal-file-input').on('change', function(e){
        var container = $($(e.target).data('files-list'));

        // Delete existing logo from list
        container.find('a.delete-logo').click();

        fileInputListUploader(e);
    });

    var fileSize = function (size) {
        switch (true) {
        case (size <= 1024):
            return `${size} байт`
        case size <= 1024*1024:
            return `${(size/1024).toFixed(1)} Кб`
        case size > 1024*1024:
            return `${(size/(1024*1024)).toFixed(1)} Мб`
        }
    }
    var fileInputListUploader = function (e) {
        // Add files to files-list
        var fileinput = $(e.target).clone();
        var inputName = $(e.target).data('files-input-name').replace(/__IDX__/, Math.random().toFixed(36).substring(2, 8));

        $(fileinput).removeAttr('id')
        $(fileinput).attr('name', inputName);

        var maxLength = 20
        var filename = e.target.files[0].name;
        filename = filename.length > maxLength ? filename.substring(0, maxLength) + "..." : filename;
        var filesize = fileSize(e.target.files[0].size);
        var container = $($(e.target).data('files-list'));
        var item = $.parseHTML(container.data('file-tpl'));

        $(e.target).val('');
        $(item).prepend($(fileinput));
        $(item).find(".name").prepend(filename);
        $(item).find(".filesize").prepend(filesize);
        container.prepend($(item));
    };

    $(document).on('click', "[data-delete-file-item]", function (e) {
        $(e.currentTarget).closest($(e.currentTarget).data('delete-file-item')).remove();
    });
});
